function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1 0h14a1 1 0 010 2H1a1 1 0 010-2zm2 5h10a1 1 0 010 2H3a1 1 0 010-2zm2 5h6a1 1 0 010 2H5a1 1 0 010-2z"
});

function SvgCardFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 12"
  }, props), _ref);
}

export default SvgCardFilter;